import classNames from 'classnames';
import { Badge } from 'components/ui';
import React, { FC } from 'react';
import styles from './TypesInfo.module.scss';

export interface ITypesInfo {
  name: string;
  types: string[];
  className?: string;
}

const TypesInfo: FC<ITypesInfo> = (props) => {
  const { name, types, className } = props;
  const rootClassName = classNames(styles.root, className);

  return (
    <div className={rootClassName}>
      <p className={styles.title}>{name}</p>
      <ul className={styles.types}>
        {types.map(
          (type) =>
            type && (
              <li className={styles.type} key={type}>
                <Badge text={type} />
              </li>
            )
        )}
      </ul>
    </div>
  );
};

export default TypesInfo;
